import {Text, View} from "@react-pdf/renderer";
import React, {useContext} from "react";

import { baseStyles } from "../../styles";
import {PDFContext} from "../../BasePDF";


export const PurchaseCustomerPriceBreakdownPDF = () => {
    const pdfData = useContext(PDFContext)
    if (!pdfData) return null;

    return (
        <View style={{...baseStyles.marginRight, ...baseStyles.table}}>
            <View style={{...baseStyles.tableHeader, backgroundColor: pdfData.pageColor}}>
                <Text>Price Breakdown</Text>
            </View>

            <View>
                <View style={baseStyles.flexBetween}>
                    <Text>Selling Price</Text>
                    <Text>{pdfData.selling_price.toDollarFormat()}</Text>
                </View>

                <View style={baseStyles.flexBetween}>
                    <Text>Sales Tax</Text>
                    <Text>{pdfData.total_taxes.toDollarFormat()}</Text>
                </View>

                <View style={{...baseStyles.flexBetween}}>
                    <Text>Customer Rebate (Disc)</Text>
                    <Text>{pdfData.total_rebates.toDollarFormat()}</Text>
                </View>

                <View style={baseStyles.flexBetween}>
                    <Text>Fees</Text>
                    <Text>{pdfData.total_fees.toDollarFormat()}</Text>
                </View>

                {/*<View style={{...baseStyles.boldTopBorder, ...baseStyles.flexBetween}}>*/}
                {/*    <Text>Total Sale Price</Text>*/}
                {/*    /!*<Text>{helper.totalSalePrice().toDollarFormat()}</Text>*!/*/}
                {/*    <View>FIX HERE TOTAL SALE PRICE</View>*/}
                {/*</View>*/}
            </View>
        </View>
    )
}